/** Auth channel: Radical embed token vs hospital CRE (CIAM). */
export const AUTH_SOURCE = {
  RADICAL: "RADICAL",
  CRE: "CRE",
};

export function isCreAuthSource(source) {
  return source === AUTH_SOURCE.CRE;
}

/** CRE loads study via Reporting `GetUserStudy`. */
export function usesReportingGetUserStudy(source) {
  return source === AUTH_SOURCE.CRE;
}

export function authSourceFromSystemCode(systemCode) {
  if (!systemCode) return null;
  const code = String(systemCode).toUpperCase();
  if (code === AUTH_SOURCE.RADICAL) return AUTH_SOURCE.RADICAL;
  if (code === AUTH_SOURCE.CRE || code === "ENTERPRISE") return AUTH_SOURCE.CRE;
  return null;
}

/** Lowercase provider id for report-engine / extension integrations. */
export function integrationAuthProvider(authSource) {
  if (authSource === AUTH_SOURCE.CRE) return "cre";
  return "radical";
}
